<template>
    <home-template>
        <v-layout wrap justify-space-around align-center>
              <v-card>
                <v-card-title primary-title>
                    <v-avatar size=150 color="teal">
                        <v-icon size=150 dark>account_circle</v-icon>
                    </v-avatar>
                </v-card-title>
                <v-card-actions>
                    <v-btn >5 jogos</v-btn> <v-btn>10 vitórias</v-btn>
                </v-card-actions>
            </v-card>
        </v-layout>
        <v-layout row wrap justify-space-around center xs6 offset-xs-3>
         <v-flex xs4>
              <v-btn color="info">amigos</v-btn><v-btn color="success">novo jogo</v-btn>
         </v-flex>
        </v-layout>
    </home-template>
</template>

<script>
import HomeTemplate from '@/components/pages/templates/HomeTemplate'
export default {
    name: 'HomePage',
    components: {
        HomeTemplate
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/HomePage.vue